var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orders--page"},[_c('SideNav2'),_c('div',{staticClass:"orders--container"},[_c('ShippingOrders')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }